import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import IBimageKneeanglemidstance1 from '@/pages/ReportV2/components/Modals/assets/IBimageKneeanglemidstance1.png';
import IBimageKneeanglemidstance2 from '@/pages/ReportV2/components/Modals/assets/IBimageKneeanglemidstance2.png';
// Styles
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { VerticalSwiper } from '@/components/swiper';

export const KneeFlexionMidstanceRunModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='11' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageKneeanglemidstance1} />
                </div>
              </IonCol>
              <IonCol size='11' size-lg='5' size-xl='5'>
                <div>
                  During running, the COM will perform a wave movement, with its highest point at the middle of the
                  floating phase and lowest at midstance.
                  <br></br>
                  <br></br>
                  Due to the lowering COM after landing, the body must absorb massive ground reaction forces. Accurate
                  response to this sudden loading requires sufficient leg stiffness (also see: swing leg retraction).
                  <br></br>
                  <br></br>
                  The kinetic energy released is converted into elastic energy as much as possible, which is being
                  stored in elastic components such as tendons and fascia for re-use after midstance.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow class='ion-justify-content-center ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='11' size-lg='6' size-xl='6'>
                <div>
                  <IonImg class={styles.avatar} src={IBimageKneeanglemidstance2} />
                </div>
              </IonCol>
              <IonCol size='11' size-lg='5' size-xl='5'>
                <div>
                  The knee is a key hub for transport of energy from proximal to distal, in which the muscle effort arms
                  change along with the knee angle and hence also the joint torque. Therefore the knee angle at
                  midstance is an important parameter to check economic running.
                  <br></br>
                  <br></br>
                  The right (maximum) knee angle in stance phase is critical for running at high speed; slightly larger
                  angles lead to a deeper ‘sit’, resulting in loss of performance.
                  <br></br>
                  <br></br>
                  Lack of stiffness typically forces the knee to ‘collapse’. This results in larger knee angles which
                  disable the possibility to store elastic energy.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
